import React, { useState } from 'react';
import { Shield, X, ShieldCheck, Lock, RefreshCw } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/5yJUmvh9YcA85AWox7xXA1/logo_neurolecturas.png';
type ModalType = 'terms' | 'privacy' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-[#080e1a] text-white py-12 border-t border-white/5" data-id="element-55">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
          <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-57">
            <div className="flex items-center mb-4 md:mb-0" data-id="element-58">
              <Shield className="w-8 h-8 text-[#c0392b] mr-3" data-id="element-59" />
              <span className="font-serif font-bold text-xl tracking-wide" data-id="element-60">
                INVISIBLES PERO INVENCIBLES
              </span>
            </div>
            <div className="flex space-x-6 text-sm text-gray-400 font-sans" data-id="element-61">
              <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors" data-id="element-62">
                Términos
              </button>
              <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors" data-id="element-63">
                Privacidad
              </button>
              <a href="mailto:hola@neurolecturaspro.com" className="hover:text-white transition-colors" data-id="element-64">
                Contacto
              </a>
            </div>
          </div>

          {/* Trust Badges */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8 border-b border-white/10 pb-8" data-id="element-65">
            <div className="flex items-center bg-white/5 border border-white/10 rounded px-4 py-3" data-id="element-66">
              <ShieldCheck className="w-6 h-6 text-green-400 mr-3 flex-shrink-0" data-id="element-67" />
              <div data-id="element-68">
                <p className="text-white text-xs font-bold uppercase tracking-wide" data-id="element-69">
                  Pago 100% Seguro
                </p>
                <p className="text-gray-500 text-xs" data-id="element-70">SSL Encriptado</p>
              </div>
            </div>
            <div className="flex items-center bg-white/5 border border-white/10 rounded px-4 py-3" data-id="element-71">
              <Lock className="w-6 h-6 text-green-400 mr-3 flex-shrink-0" data-id="element-72" />
              <div data-id="element-73">
                <p className="text-white text-xs font-bold uppercase tracking-wide" data-id="element-74">
                  Compra Protegida
                </p>
                <p className="text-gray-500 text-xs" data-id="element-75">
                  Procesado de forma segura
                </p>
              </div>
            </div>
            <div className="flex items-center bg-white/5 border border-white/10 rounded px-4 py-3" data-id="element-76">
              <RefreshCw className="w-6 h-6 text-green-400 mr-3 flex-shrink-0" data-id="element-77" />
              <div data-id="element-78">
                <p className="text-white text-xs font-bold uppercase tracking-wide" data-id="element-79">
                  Actualizado 2026
                </p>
                <p className="text-gray-500 text-xs" data-id="element-80">Contenido vigente</p>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 text-center md:text-left" data-id="element-81">
            <p className="text-gray-500 text-sm font-sans mb-4" data-id="element-82">
              © 2026 NeuroLecturas Pro. Todos los derechos reservados.
            </p>
            <p className="text-gray-600 text-xs font-sans max-w-3xl mb-4" data-id="element-83">
              DESCARGO DE RESPONSABILIDAD: Esta guía es un recurso educativo e
              informativo y no constituye asesoría legal profesional. El uso de
              esta información no crea una relación abogado-cliente. Las leyes
              de inmigración son complejas y cambian constantemente; para casos
              específicos, siempre recomendamos consultar con un abogado de
              inmigración calificado.
            </p>
            <p className="text-gray-500 text-xs font-sans max-w-3xl" data-id="element-84">
              Nota: Todos los correos electrónicos y el ebook serán enviados
              desde la dirección oficial de NeuroLecturas Pro (
              <a href="mailto:hola@neurolecturaspro.com" className="text-[#c0392b] hover:underline" data-id="element-85">
                hola@neurolecturaspro.com
              </a>
              ). Revisa tu bandeja de entrada y la carpeta de correo no deseado
              para asegurarte de recibirlo sin problemas.
            </p>

            {/* NeuroLecturas Pro branding */}
            <div className="border-t border-white/10 mt-8 pt-6 flex flex-col items-center md:items-start" data-id="element-86">
              <div className="flex items-center mb-3" data-id="element-87">
                <img src={LOGO_URL} alt="NeuroLecturas Pro logo" className="w-8 h-8 rounded-full object-cover flex-shrink-0" data-id="element-88" />
                <span className="ml-2 font-sans font-semibold text-white text-sm tracking-wide" data-id="element-89">
                  NeuroLecturas Pro
                </span>
              </div>
              <p className="text-gray-500 text-xs font-sans" data-id="element-90">
                Este producto es entregado y respaldado por NeuroLecturas Pro –{' '}
                <a href="mailto:hola@neurolecturaspro.com" className="text-[#c0392b] hover:underline" data-id="element-91">
                  hola@neurolecturaspro.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-92">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={closeModal} data-id="element-93">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="relative bg-[#0c1222] border border-white/10 w-full max-w-2xl max-h-[85vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-94">
              {/* Header */}
              <div className="sticky top-0 bg-[#0c1222] border-b border-white/10 px-6 sm:px-8 py-5 flex items-center justify-between z-10" data-id="element-95">
                <h2 className="font-serif font-bold text-xl sm:text-2xl text-white uppercase tracking-wide" data-id="element-96">
                  {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
                </h2>
                <button onClick={closeModal} className="text-gray-400 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-97">
                  <X className="w-6 h-6" data-id="element-98" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 sm:px-8 py-8 space-y-6 font-sans text-gray-300 text-sm sm:text-base leading-relaxed" data-id="element-99">
                {activeModal === 'terms' ? <TermsContent data-id="element-100" /> : <PrivacyContent data-id="element-101" />}

                <div className="border-t border-white/10 pt-6 mt-8" data-id="element-102">
                  <p className="text-gray-500 text-xs" data-id="element-103">
                    Para cualquier consulta, escríbenos a{' '}
                    <a href="mailto:hola@neurolecturaspro.com" className="text-[#c0392b] hover:underline" data-id="element-104">
                      hola@neurolecturaspro.com
                    </a>
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function TermsContent() {
  return <>
      <p data-id="element-105">
        Bienvenido a nuestro sitio web. Al acceder y utilizar este sitio,
        aceptas cumplir y estar sujeto a los siguientes términos y condiciones
        de uso. Si no estás de acuerdo con alguna parte de estos términos, por
        favor no utilices nuestro sitio.
      </p>

      <div data-id="element-106">
        <h3 className="font-bold text-white text-base sm:text-lg mb-2" data-id="element-107">
          Uso del Contenido
        </h3>
        <p data-id="element-108">
          Todo el contenido proporcionado en este sitio es únicamente para fines
          informativos. No constituye asesoría legal, profesional o
          especializada.
        </p>
      </div>

      <div data-id="element-109">
        <h3 className="font-bold text-white text-base sm:text-lg mb-2" data-id="element-110">
          Responsabilidad
        </h3>
        <p data-id="element-111">
          No nos hacemos responsables de cualquier uso que se le dé a la
          información contenida en el e-book u otros materiales. El uso del
          contenido es bajo tu propia responsabilidad.
        </p>
      </div>

      <div data-id="element-112">
        <h3 className="font-bold text-white text-base sm:text-lg mb-2" data-id="element-113">
          Propiedad Intelectual
        </h3>
        <p data-id="element-114">
          Todos los derechos de propiedad intelectual del contenido del sitio,
          incluyendo textos, imágenes y diseño, son de nuestra propiedad o de
          nuestros licenciantes.
        </p>
      </div>

      <div data-id="element-115">
        <h3 className="font-bold text-white text-base sm:text-lg mb-2" data-id="element-116">
          Modificaciones
        </h3>
        <p data-id="element-117">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Es tu responsabilidad revisar periódicamente esta página para
          estar al tanto de cualquier cambio.
        </p>
      </div>

      <div data-id="element-118">
        <h3 className="font-bold text-white text-base sm:text-lg mb-2" data-id="element-119">
          Enlaces a Terceros
        </h3>
        <p data-id="element-120">
          Este sitio puede contener enlaces a sitios web de terceros. No tenemos
          control sobre el contenido o las políticas de esos sitios y no
          asumimos ninguna responsabilidad al respecto.
        </p>
      </div>
    </>;
}
function PrivacyContent() {
  return <>
      <p data-id="element-121">
        Tu privacidad es muy importante para nosotros. A continuación, te
        explicamos cómo manejamos tu información personal.
      </p>

      <div data-id="element-122">
        <h3 className="font-bold text-white text-base sm:text-lg mb-2" data-id="element-123">
          Recolección de Información
        </h3>
        <p data-id="element-124">
          Recopilamos tu nombre y dirección de correo electrónico cuando accedes
          a nuestro contenido gratuito o realizas una compra. Esta información
          se utiliza únicamente para enviarte los productos adquiridos,
          comunicaciones relacionadas y actualizaciones.
        </p>
      </div>

      <div data-id="element-125">
        <h3 className="font-bold text-white text-base sm:text-lg mb-2" data-id="element-126">
          Uso de la Información
        </h3>
        <p data-id="element-127">
          No compartimos tu información personal con terceros, excepto cuando
          sea estrictamente necesario para el procesamiento de pagos (por
          ejemplo, a través de Shopify o plataformas de pago seguras) o para
          cumplir con obligaciones legales.
        </p>
      </div>

      <div data-id="element-128">
        <h3 className="font-bold text-white text-base sm:text-lg mb-2" data-id="element-129">
          Compartición de Datos con Terceros
        </h3>
        <p data-id="element-130">
          Podremos compartir sus datos personales con terceros de confianza
          únicamente cuando sea necesario para cumplir con los fines descritos
          en este libro. Esto incluye, por ejemplo, referirle a profesionales
          que puedan ayudarle en la protección de sus derechos. Nunca venderemos
          su información a terceros no vinculados con esta misión.
        </p>
      </div>

      <div data-id="element-131">
        <h3 className="font-bold text-white text-base sm:text-lg mb-2" data-id="element-132">
          Seguridad
        </h3>
        <p data-id="element-133">
          Implementamos medidas de seguridad razonables para proteger tu
          información personal, aunque no podemos garantizar la seguridad
          completa en línea.
        </p>
      </div>

      <div data-id="element-134">
        <h3 className="font-bold text-white text-base sm:text-lg mb-2" data-id="element-135">
          Derechos del Usuario
        </h3>
        <p data-id="element-136">
          En cualquier momento puedes solicitar la eliminación de tu información
          de nuestra base de datos. Para ello, contáctanos en{' '}
          <a href="mailto:hola@neurolecturaspro.com" className="text-[#c0392b] hover:underline" data-id="element-137">
            hola@neurolecturaspro.com
          </a>
          .
        </p>
      </div>

      <div data-id="element-138">
        <h3 className="font-bold text-white text-base sm:text-lg mb-2" data-id="element-139">
          Cambios a la Política
        </h3>
        <p data-id="element-140">
          Nos reservamos el derecho de modificar esta política en cualquier
          momento. Cualquier cambio será notificado en esta misma página.
        </p>
      </div>
    </>;
}